import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserActions, MessagesActions, ValidationActions } from '../../actions';
import { BoxTitle, ImagePreview } from '../PageTemplate';
import { Submit, File, DoubleClickBtn } from '../Form';

const {REACT_APP_LOGO_FILE_TYPES, REACT_APP_LOGO_MAX_FILE_SIZE} = process.env;

class LogoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            file: null,
            deleteLogoOk: false,
            fileInput: null // save dom of input file (for clean on submit)
        }

        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.deleteLogo = this.deleteLogo.bind(this);
    }

    handleFileChange(event) {
        var file = event.target.files[0];
        if(!file) return;

        const {dispatch} = this.props;

        const validType = dispatch(ValidationActions.fileType(file.type, JSON.parse(REACT_APP_LOGO_FILE_TYPES)));
        const validSize = dispatch(ValidationActions.fileSize(file.size, Number(REACT_APP_LOGO_MAX_FILE_SIZE)));

        // if(this.validateFileType(file.type) && this.validateFileSize(file.size)){
        if(validType && validSize) {
             return this.setState({file: file, fileInput: event.target});
        }

        event.target.value = '';
        return this.setState({file: null});
    }

    handleSubmit(event) {
        event.preventDefault();
        const {dispatch} = this.props;

        if(!this.state.file) {
            dispatch(MessagesActions.pushInfo(`קודם צריך לבחור תמונה`));
            return;
        }
        
        dispatch(UserActions.uploadLogo(this.state.file));
        
        var fileInput = this.state.fileInput; // get dom of input file
        fileInput.value = ''; // clean it
        this.setState({file: null, fileInput: null});
    }

    deleteLogo() {
        const {dispatch, user} = this.props;

        if(user.deleteLogoProcess === true) return;

        if(!this.state.deleteLogoOk) {
            return this.setState({deleteLogoOk: true});
        }

        this.setState({deleteLogoOk: false});
        dispatch(UserActions.deleteLogo());
    }

    render() {
        const {user} = this.props;
        const hasLogo = user.data && user.data.logo;
        const userLogo = hasLogo ? user.data.logo.url : false;
        const allowedFileTypes = "image/" + JSON.parse(REACT_APP_LOGO_FILE_TYPES).join(",image/");
        const uploadInProgress = user.uploadLogoProcess === true;
        const deleteInProgress = user.deleteLogoProcess === true;   

        return (
            <div id="logoForm">
                <BoxTitle icon="faAddressCard">
                    לוגו העסק
                </BoxTitle>
                <div className="subTitleDescription">
                    הלוגו יופיע בדפי הסלפי של האירועים שלכם כך שכל האורחים ידעו מי אתם
                </div>
                <ImagePreview 
                    image={userLogo}
                    text="הוסיפו את הלוגו שלכם"
                />
                <form onSubmit={this.handleSubmit} className={`${!hasLogo ? 'noLogo': ''}`}>
                    <File 
                        name="logo"
                        onChange={this.handleFileChange}
                        accept={allowedFileTypes}
                        placeholder="בחרו לוגו"
                    />
                    <Submit process={uploadInProgress} icon="faCloudUploadAlt" className={`${this.state.file ? 'hasFile' : ''}`} text="שמירה"/>
                    <DoubleClickBtn
                        className={`deleteFile ${hasLogo ? '' : 'hide'}`}
                        process={deleteInProgress}
                        clicked={this.state.deleteLogoOk}
                        icon="faTrashAlt"
                        textOne="מחיקה"
                        textTwo="בטוח?"
                        onClick={this.deleteLogo}
                    />
                </form>
                <div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer
    }
}

const LogoFormWithRedux = connect(mapStateToProps)(LogoForm);

export {LogoFormWithRedux as LogoForm};


// WEBPACK FOOTER //
// ./src/components/ProfilePage/LogoForm.jsx